module.exports = __webpack_public_path__ + "static/media/123e.148e1ab.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/123e.mp4
// module id = nqtr
// module chunks = 0